import { ChangeDetectionStrategy, Component, computed, inject, signal, HostListener } from '@angular/core';
import { UserService } from '../../../common/service/user.service';

import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';
import { PlatformService } from '../../../common/service/platform.service';
import { UserPreferenceService } from '../../../common/service/user-preference.service';

@Component({
  selector: 'gate-impersonation-status',
  standalone: true,
  imports: [TranslatePipe, ButtonModule],
  templateUrl: './impersonation-status.component.html',
  styleUrl: './impersonation-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImpersonationStatusComponent {
  private readonly userService = inject(UserService);
  private readonly platformService = inject(PlatformService);
  private readonly userPreferenceService = inject(UserPreferenceService);
  private router = inject(Router);

  heroVisible = signal(true);
  isVisible = computed(() => this.userService.isImpersonating() && this.impersonationContext()?.initiatorType == 'ACP_User');
  customerId = computed(() => this.userService.currentUser().customerId);
  impersonationContext = computed(() => this.userService.getImpersonationContext());
  isSmallScreen = signal<boolean>(window.innerWidth < 1024);
   @HostListener('window:resize')
  onResize() {
    this.isSmallScreen.set(window.innerWidth < 1024);
  }
  constructor() {
    this.heroVisible.set(this.userPreferenceService.showHeroSection());
    this.userPreferenceService.initialize().then(() => {
      this.heroVisible.set(this.userPreferenceService.showHeroSection());
    });
    this.platformService.heroToggleEvent.subscribe((value) => {
      this.heroVisible.set(value);
    });
  }

  toggleHeroVisible() {
    const value = !this.heroVisible();
    this.heroVisible.set(value);
    this.platformService.heroToggleEvent.emit(value);
    this.userPreferenceService.setShowHeroSection(value);
  }

  finishImpersonation() {
    this.userService.stopImpersonation().then(() => {
      this.router.navigate(['/home']).finally(() => {
        window.location.reload();
      });
    });
  }
}
